import * as Yup from "yup";
import { isOnlyCountryCode } from "../../../utils/utils";
import phoneValidation from "../../../common/components/phone-number-input-component/phone-validation";

const dynamicFieldValidationSchema: Record<string, Yup.AnySchema> = {
    customerOwner: Yup.string()
        .required("Customer Owner cannot be empty")
        .max(100, "Customer Owner cannot be more than 100 characters"),

    company: Yup.string()
        .required("Company cannot be empty")
        .max(150, "Company cannot be more than 150 characters"),

    fax: Yup.string()
        .required("Fax cannot be empty")
        .test("is-valid-fax", "Please enter a valid fax number", (value) => {
            if (!value || isOnlyCountryCode(value)) {
                return true;
            }
            return phoneValidation(value);
        }),

    description: Yup.string()
        .required("Description cannot be empty")
        .max(150, "Description cannot be more than 150 characters"),

    preferredContactMode: Yup.string()
        .required("Preferred Contact Mode cannot be empty")
        .max(100, "Preferred Contact Mode cannot be more than 100 characters"),
};

export default dynamicFieldValidationSchema;
